import {
    UserStore,
    BriefStore,
    SimpleStore,
    StatisticsStore,
    PagePathStore,
    MIXPANEL_EVENT_PROPERTIES,
    BriefSourceStore,
    ReferrerStore,
} from '../../../shared/mixpanel';

const { LOCATION, FROM_BOOST } = MIXPANEL_EVENT_PROPERTIES;

export default {
    user: new UserStore(),
    brief: new BriefStore(),
    editBriefButtonLocation: new SimpleStore<typeof LOCATION, string>(LOCATION),
    statistics: new StatisticsStore(),
    pagePath: new PagePathStore(),
    briefSource: new BriefSourceStore(),
    fromBoost: new SimpleStore<typeof FROM_BOOST, number>(FROM_BOOST),
    referrer: new ReferrerStore(),
};
